module.exports = __webpack_public_path__ + "static/media/Load Only the Steel Connections You Need.7136b598.png";